module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', [_c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Uncovered amount")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("hello")])])]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dcd6db14!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/ReservationUncoveredAmount.vue
// module id = 2558
// module chunks = 1